<template>
	<header>
		<h2>EuSIGN</h2>
	</header>
</template>

<script>
export default {
  name: 'HeaderTop',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2{
  padding: 15px;
  margin: 0;
  font-weight: 600;
  position: fixed;
  top: 0;
  background-color: #fff;
  text-align: center;
  width: 100%;
  z-index: 0;
  border-bottom: 1px solid #efeeee;
  font-size: 24px;
}

/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>
